var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('h1',[_vm._v("Editar contato do concedente")]),_c('b-card',[_c(_setup.Form,{attrs:{"concedente_contato_id":_setup.$route.params.id ?? null},on:{"saved":_setup.loadData}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }